<table class="ap-calendar-table">
    <caption class="ap-sr-only">
        Selecteer een maand
    </caption>
    <thead class="ap-calendar-table-header">
        <tr>
            <th class="ap-calendar-table-header-divider" colspan="4"></th>
        </tr>
    </thead>
    <tbody
        ap-calendar-body
        aria-readonly="true"
        tabindex="0"
        [label]="_yearLabel"
        [rows]="_months"
        [todayValue]="_todayMonth"
        [selectedValue]="_selectedMonth"
        [numCols]="4"
        [cellAspectRatio]="4 / 7"
        [activeCell]="getMonth(activeDate)"
        (selectedValueChange)="_monthSelected($event)"
        (keydown)="_handleCalendarBodyKeydown($event)"
    ></tbody>
</table>
